import * as constants from "./constants";

const initialState = {
  loading: false,
  allCallHistories: [],
  totalRecords: 0,
  error: null,
};

const callHistoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_ALL_CALL_HISTORIES:
      return { ...state, loading: true, error: null };

    case constants.FETCH_ALL_CALL_HISTORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        allCallHistories: action.data.allCallHistories,
        totalRecords: action.data.totalRecords,
      };

    case constants.FETCH_ALL_CALL_HISTORIES_ERROR:
      return { ...state, loading: false, error: action.error };

    default:
      return state;
  }
};

export default callHistoriesReducer;
